// ─────────────────────────────────────────────────────────────────────────────
// AXIS360 SalesAxis — Question Bank
// 24 items · 3 sections · Likert 1-5 · Indian sales professional context
// Science: Barrick & Mount (1991) personality + sales performance · Mayer (2000)
// ─────────────────────────────────────────────────────────────────────────────

export const SALESAXIS_SECTIONS = [
  { id:"personality", label:"Sales Personality", icon:"🧠", color:"#0B2545", items:8 },
  { id:"knowledge",   label:"Sales Knowledge",   icon:"📚", color:"#C8973A", items:8 },
  { id:"motivation",  label:"Sales Motivation",  icon:"🔥", color:"#2E7D32", items:8 },
];

export const SALESAXIS_ITEMS = [

  // ── PERSONALITY (P1-P8) ──────────────────────────────────────────────────
  { id:"sm01", section:"personality", subDim:"Drive & Persistence", keyItem:true,
    q:"I continue pursuing a sale even after the prospect has said no multiple times." },
  { id:"sm02", section:"personality", subDim:"Resilience", keyItem:true,
    q:"I recover quickly from a lost deal and move to the next opportunity without dwelling on it." },
  { id:"sm03", section:"personality", subDim:"Confidence", keyItem:true,
    q:"I am comfortable presenting to senior decision-makers and board-level stakeholders." },
  { id:"sm04", section:"personality", subDim:"Persuasion", keyItem:true,
    q:"I can shift a sceptical client\'s perspective by reframing the conversation around their priorities." },
  { id:"sm05", section:"personality", subDim:"Competitiveness", keyItem:true,
    q:"I track my own performance metrics and compare them against colleagues or targets weekly." },
  { id:"sm06", section:"personality", subDim:"Adaptability", keyItem:false,
    q:"I adjust my communication style significantly depending on whether I am talking to a finance person, a technical person, or a business owner." },
  { id:"sm07", section:"personality", subDim:"Self-Discipline", keyItem:true,
    q:"I maintain high call/meeting activity even during slow periods when deals are not closing." },
  { id:"sm08", section:"personality", subDim:"Goal Orientation", keyItem:false,
    q:"I set personal sales targets that are higher than the official quota assigned to me." },

  // ── KNOWLEDGE (K1-K8) ────────────────────────────────────────────────────
  { id:"sm09", section:"knowledge", subDim:"Sales Process", keyItem:true,
    q:"I qualify every prospect using a structured framework (e.g. BANT or SPIN) before investing significant time." },
  { id:"sm10", section:"knowledge", subDim:"Objection Handling", keyItem:true,
    q:"I have a prepared, well-practised response for the five most common objections in my category." },
  { id:"sm11", section:"knowledge", subDim:"Needs Analysis", keyItem:true,
    q:"I ask more questions than I make statements in a first client meeting." },
  { id:"sm12", section:"knowledge", subDim:"Value Articulation", keyItem:true,
    q:"I can clearly articulate the ROI of my product or service in financial terms relevant to the customer\'s business." },
  { id:"sm13", section:"knowledge", subDim:"Closing Techniques", keyItem:false,
    q:"I always confirm a specific next step with a date and person responsible before leaving a client meeting." },
  { id:"sm14", section:"knowledge", subDim:"Competitor Knowledge", keyItem:false,
    q:"I know the three main weaknesses of my top two competitors and use them when differentiating my offer." },
  { id:"sm15", section:"knowledge", subDim:"Pipeline Discipline", keyItem:true,
    q:"My CRM pipeline is up-to-date at all times and I can forecast the month\'s close accurately." },
  { id:"sm16", section:"knowledge", subDim:"Solution Matching", keyItem:false,
    q:"I have a clear mental map of which customer profiles best match each of my products or solutions." },

  // ── MOTIVATION (M1-M8) ───────────────────────────────────────────────────
  { id:"sm17", section:"motivation", subDim:"Financial Drive", keyItem:true,
    q:"Earning significantly above my base salary through variable pay is a primary reason I choose sales roles." },
  { id:"sm18", section:"motivation", subDim:"Achievement", keyItem:true,
    q:"Exceeding my quarterly target gives me more satisfaction than any other professional milestone." },
  { id:"sm19", section:"motivation", subDim:"Recognition", keyItem:false,
    q:"Being recognised publicly as a top performer in front of peers motivates me more than a private bonus." },
  { id:"sm20", section:"motivation", subDim:"Customer Success", keyItem:true,
    q:"I feel genuine satisfaction when a product I sold has delivered measurable results for the client." },
  { id:"sm21", section:"motivation", subDim:"Continuous Growth", keyItem:false,
    q:"I spend time each week learning about sales techniques, market trends or product knowledge on my own initiative." },
  { id:"sm22", section:"motivation", subDim:"Accountability", keyItem:true,
    q:"I take full personal responsibility for my numbers — I never attribute underperformance to external factors." },
  { id:"sm23", section:"motivation", subDim:"Competitive Drive", keyItem:false,
    q:"I find it motivating to work in an environment where performance rankings are visible to the whole team." },
  { id:"sm24", section:"motivation", subDim:"Long-term Mindset", keyItem:true,
    q:"I prioritise building long-term client relationships over maximising short-term commissions, even when it costs me today." },
];

export const SALESAXIS_SCALE = [
  { value:1, label:"Strongly Disagree" },
  { value:2, label:"Disagree" },
  { value:3, label:"Neutral" },
  { value:4, label:"Agree" },
  { value:5, label:"Strongly Agree" },
];
